import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Button, Box } from "@mui/material";

function Pagination({
  page,
  setPage,
  totalItems,
  itemsPerPage,
}: {
  page: number;
  setPage: (page: number) => void;
  totalItems: number;
  itemsPerPage: number;
}) {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const pages = Array.from({ length: totalPages }, (_, index) => index);

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      gap={1}
      mt={2}
    >
      <Button
        onClick={() => setPage(0)}
        disabled={page === 0}
        startIcon={<FirstPageIcon />}
      />
      <Button
        onClick={() => setPage(page - 1)}
        disabled={page === 0}
        startIcon={<NavigateBeforeIcon />}
      />
      {pages.map((pageNumber) => (
        <Button
          key={pageNumber}
          onClick={() => setPage(pageNumber)}
          variant={page === pageNumber ? "contained" : "outlined"}
          sx={{
            borderRadius: "100%",
            width: "36px !important",
            minWidth: "36px",
          }}
        >
          {pageNumber + 1}
        </Button>
      ))}
      <Button
        onClick={() => setPage(page + 1)}
        disabled={page + 1 >= totalPages}
        endIcon={<NavigateNextIcon />}
      />
      <Button
        onClick={() => setPage(totalPages - 1)}
        disabled={page + 1 >= totalPages}
        endIcon={<LastPageIcon />}
      />
    </Box>
  );
}

export default Pagination;
